module.exports = __webpack_public_path__ + "static/media/christ.0c14ec89.jpg";